// Feature Configurations
import { User } from '@centecomm/portal-service';
import { useCurrentUser } from '@centecomm/portal-service-react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import useSettingsFromState from 'State/Settings/Hooks/useSettingsFromState';

import { FeatureConfiguration } from '../Types/FeatureConfiguration';
import { FeatureRoute } from '../Types/FeatureRoute';
import { NavigationLink } from '../Types/NavigationLink';
import { buildFeatureVisibilityContext } from './featureVisibility';
import filterMainFeatures from './filterMainFeatures';
import filterNavigationLinks from './filterNavigationLinks';
import useGetNestedRoutes from './useGetNestedRoutes';

function useFeatureRoutes(featureConfigurations: FeatureConfiguration[]): {
    navigationLinks: NavigationLink[];
    featureRoutes: FeatureRoute[];
} {
    const { settings } = useSettingsFromState();
    const { hasPermission, currentUser } = useCurrentUser();
    const ldClient = useLDClient();
    const nestedConfigurations = useGetNestedRoutes(featureConfigurations);
    const nestedFeatureConfigurations = [...featureConfigurations, ...nestedConfigurations];

    const visibilityContext = buildFeatureVisibilityContext(currentUser as User, hasPermission, ldClient, settings);

    const navigationLinks: NavigationLink[] = filterNavigationLinks(
        featureConfigurations,
        hasPermission,
        currentUser as User,
        visibilityContext,
        settings,
        ldClient,
    );

    const featureRoutes: FeatureRoute[] = filterMainFeatures(
        nestedFeatureConfigurations,
        hasPermission,
        currentUser as User,
        visibilityContext,
        settings,
        ldClient,
    );

    return { navigationLinks, featureRoutes };
}

export default useFeatureRoutes;
